<template>
  <section class="flex artist-banner top-xs pt70 container px20 c-white">
    <div class="row m0">
      <div class="artist-banner-text">
        <div class="artist-banner-text-heading row m0 start-md left-0 top-0 w-100">
          <h1 class="c-white mt20">
            {{ artistName }}
          </h1>
        </div>
        <div class="artist-banner-text-description flex pr144 pb24-desktop pb8-tablet c-white hidden-mobile">
          <span
            v-html="artistShortDescription"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { htmlDecode } from '@vue-storefront/core/filters'

export default {
  props: {
    artist: {
      type: Object,
      required: true
    }
  },
  computed: {
    artistName () {
      return this.artist.name
    },
    artistDescription () {
      return this.artist.description
    },
    artistShortDescription () {
      return htmlDecode(this.artist.short_description)
    },
    artistImage () {
      return this.artist.image
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/variables/grid';
@import '~theme/css/helpers/functions/z-index-selectors';

.artist-banner {
  z-index: zIndex(banner);
  max-width: 100%;
  display: flex;
  align-items: end;

  &-text-heading {
    h1 {
      padding-top: 0;
      font-size: 22px;
      line-height: 27px;
      margin-bottom: 24px;
    }
  }

  span {
    /deep/ p {
      line-height: 17px;

      &:first-of-type {
        margin-top: 0;
        margin-bottom: 16px;
      }
    }
  }

  &-image {
    z-index: zIndex(banner-image);
  }
}

@include tablet {
  .artist-banner {
    padding-top: 0;
    display: flex;
    align-items: end;

    &-text-heading {
      h1 {
        font-size: 40px;
        padding-top: 0;
      }
    }

    &-image {
      max-height: 292px;
    }
  }
}

@include desktop {
  .artist-banner {
    padding-right: 85px;
    padding-left: 25%;
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 0;
    display: flex;
    align-items: center;

    &-text-heading {
      h1 {
        margin: 0;
        margin-bottom: 12px;
        font-size: 40px;
        line-height: 48px;
        padding: 0;
      }
    }

    &-text-description {
      padding: 0;

      span {
        /deep/ p {
          line-height: 22px;

          &:last-of-type {
            margin: 0;
            padding: 0;
          }
        }
      }
    }

    &-image {
      max-height: 374px;
    }
  }
}

@include mediaQuery(sm) {
  .artist-banner {
    padding-bottom: 0;

    &-text {
      flex-direction: column;

      &-heading {
        padding-left: 0;
        padding-right: 0;
        position: relative;

        h1 {
          text-transform: none;
        }
      }

      &-description {
        padding-right: 0;
      }
    }

    &-image {
      padding-top: 0;
      padding-right: 0;
      position: relative;
      height: 100%;
    }
  }
}
</style>
